import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
interface TimelineContainerProps<T> {
  children: React.ReactNode
  data: T[] | undefined
  itemSpacing?: number
}
export function TimelineContainer<T>({
  children,
  data = [],
  itemSpacing = 70,
}: TimelineContainerProps<T>) {
  const lineWidth = data?.length * itemSpacing + 180
  return (
    <div className="h-52 overflow-x-auto overflow-y-hidden">
      <div
        className="h-16 w-full min-w-full p-4 text-zinc-400"
        style={{ width: `${lineWidth}px` }}
      >
        <div className="relative mt-36 h-1 w-full bg-zinc-400">
          <div className="absolute -bottom-2.5 size-6 rounded-full bg-zinc-400" />
          <div className="absolute -bottom-3 -right-0.5">
            <div className="h-0 w-0 border-b-[14px] border-l-[22px] border-t-[14px] border-b-transparent border-l-zinc-400 border-t-transparent" />
          </div>
          <TooltipProvider>{children}</TooltipProvider>
        </div>
      </div>
    </div>
  )
}
interface TimelineItemProps {
  spaceBetween: number
  children?: React.ReactNode
  colors?: {
    bg: string
  }
  tooltip?: string
}
export const TimelineItem = ({
  spaceBetween,
  children,
  colors,
  tooltip,
}: TimelineItemProps) => {
  return (
    <div
      className="group absolute -bottom-2.5 h-fit w-[100px]"
      style={{
        left: `${spaceBetween}px`,
      }}
    >
      <div className="relative">
        <div className="mb-12 ml-1.5 w-[150px] -rotate-45 text-xs">
          {children}
        </div>
        {/*
          O gatilho é a BOLINHA, não o item inteiro. Envolvendo o item, o Radix
          media a caixa junto com o rótulo rotacionado de 150px e abria o balão
          lá em cima, à esquerda, solto do ponto que o operador apontou.
        */}
        <Tooltip delayDuration={300}>
          <TooltipTrigger asChild>
            <button
              type="button"
              aria-label={tooltip}
              className="flex size-6 cursor-pointer items-center justify-center rounded-full transition-transform hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              style={{ backgroundColor: colors?.bg }}
            >
              <div className="size-2 rounded-full bg-white" />
            </button>
          </TooltipTrigger>
          {tooltip && (
            <TooltipContent side="top" sideOffset={8}>
              {tooltip}
            </TooltipContent>
          )}
        </Tooltip>
      </div>
    </div>
  )
}
